// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleItemAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.RoleSetupConstants');
  var observer = require('mobx-react').observer;
  const { curry, get } = require('lodash/fp');
  var roleSetupAction = compose(
    connect(),
    withHandlers({
      onToggleActive: curry(onToggleActive),
      onDelete: curry(onDelete),
      onSelectRole: curry(onSelectRole)
    }),
    observer
  );

  /**
   * [on Toggle Active ]
   * @param  {object} props
   */
  function onToggleActive(props, e) {
    var loader = props.loader;
    var store = props.store;
    var role = props.roleInfo;

    e.stopPropagation();
    var togglePromise = role.active
      ? props.confirmFn('Confirmation', {
          description: constants.MESSAGE.DEACTIVE
        })
      : Promise.resolve();

    loader.startLoading();
    togglePromise
      .then(store.toggleActive.bind(store, props.roleInfo))
      .then(function(result) {
        // Handle toggle error here
        if (result.success === false) {
          var listMessage = get('messages', result);
          if (listMessage) {
            var messageObj = listMessage[0];
            var messages = get('messages', messageObj);
            if (messages) {
              return props.confirmMessage('error', messages[0]);
            }
          }
        }
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * [onDelete action]
   * @param  {object} props
   */
  function onDelete(props, e) {
    var loader = props.loader;
    var store = props.store;

    e.stopPropagation();
    loader.startLoading();
    props
      .confirmFn('Confirmation', {
        description: constants.MESSAGE.DELETE
      })
      .then(store.deleteRole.bind(store, props.roleInfo))
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * [on Select Role action]
   * @param  {object} props
   */
  function onSelectRole(props, e) {
    e.stopPropagation();
    if (props.roleInfo.isSelected) {
      return;
    }

    var loader = props.loader;
    var store = props.store;

    loader.startLoading();
    props
      .confirmDirtyForm(store.isDirty)
      .then(function() {
        props.validation.reset();
        return store.selectRole(props.roleInfo);
      })
      .finally(loader.endLoading.bind(loader));
  }

  module.exports = roleSetupAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/MiddlePanel/Izenda.RoleItemAction.js